export const LOGIN = 'login';
export const SETTOKEN = 'SETTOKEN';
export const LOGOUT = 'logout';

export const TITLE = 'title'

export const MENU = 'menu'

export const STORE = 'store'